import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2, Loader2, Info } from "lucide-react";
import { mailboxApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/components/SimpleToast";

export function MailboxRules() {
  const { user } = useAuth();
  const toast = useToast();
  const [rules, setRules] = useState(null);
  const load = () => mailboxApi.rules().then((r) => setRules(r.data)).catch(() => setRules([]));
  useEffect(() => { load(); }, []);

  const remove = async (r) => {
    if (!window.confirm(`Regel für ${r.address} löschen? Bereits zugeordnete Mails bleiben zugeordnet.`)) return;
    try { await mailboxApi.deleteRule(r.address); toast.success("Regel gelöscht"); load(); } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  if (!rules) return <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>;
  return (
    <div className="space-y-3" data-testid="mailbox-rules">
      <p className="text-sm text-muted-foreground flex items-center gap-2"><Info className="w-4 h-4" />Regeln entstehen beim manuellen Zuordnen und ordnen künftige Mails dieser Adresse automatisch zu.</p>
      {rules.length === 0 ? (
        <p className="text-sm text-muted-foreground py-10 text-center" data-testid="mailbox-rules-empty">Noch keine Regeln.</p>
      ) : (
        <Card><CardContent className="p-0 divide-y">
          {rules.map((r) => (
            <div key={r.address} className="flex flex-wrap items-center gap-3 px-4 py-3" data-testid={`mailbox-rule-${r.address}`}>
              <span className="font-medium break-all">{r.address}</span>
              <span className="text-muted-foreground">→</span>
              <Link to={r.target_type === "vendor" ? `/medical-software/${r.target_id}` : `/customers/${r.target_id}`} className="text-primary hover:underline flex-1 min-w-0 truncate">{r.target_name}</Link>
              <span className="text-xs text-muted-foreground">{r.created_by}</span>
              {user?.role === "admin" && <Button variant="ghost" size="icon" title="Regel löschen" onClick={() => remove(r)} data-testid={`mailbox-rule-delete-${r.address}`}><Trash2 className="w-4 h-4 text-destructive" /></Button>}
            </div>
          ))}
        </CardContent></Card>
      )}
    </div>
  );
}
